import React from 'react';
import { Gift } from 'lucide-react';

const NoPrizesState: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-600 to-yellow-800 flex items-center justify-center">
      <div className="text-center text-white max-w-md mx-auto p-8">
        <Gift className="h-16 w-16 mx-auto mb-4" />
        <h1 className="text-2xl font-bold mb-2">Prêmios esgotados</h1>
        <p className="text-yellow-100">
          Todos os prêmios desta roda já foram distribuídos. Obrigado pela participação!
        </p>
      </div>
    </div>
  );
};

export default NoPrizesState;
